import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Tooltip from '@material-ui/core/Tooltip';

import styles from "../../assets/jss/material-dashboard-pro-react/components/paginationStyle.js";

const useStyles = makeStyles(styles);

function TooltipButton(prop) {
    return <Tooltip title={prop.active || prop.disabled ? "" : prop.value} aria-label={prop.active || prop.disabled ? "" : prop.value}>
        <Button onClick={prop.active || prop.disabled ? null : () => prop.onClick(prop.value)} className={prop.classes}>
            {prop.text}
        </Button>
    </Tooltip>
}

export default function Pagination(props) {
  const classes = useStyles();
  const { pages, color } = props;
  return (
    <ul className={classes.pagination}>
      {pages.map((prop, key) => {
        const paginationLink = cx({
          [classes.paginationLink]: true,
          [classes[color]]: prop.active,
          [classes.disabled]: prop.disabled
        });
        return (
          <li className={classes.paginationItem} key={key}>
            {prop.onClick !== undefined ? (
              prop.tooltip ? <TooltipButton {...prop} classes={paginationLink} /> : <Button onClick={prop.active || prop.disabled ? null : () => prop.onClick(prop.value)} className={paginationLink}>
                {prop.text}
              </Button>
            ) : (
              <Button
                onClick={() => alert("you've clicked " + prop.text)}
                className={paginationLink}
              >
                {prop.text}
              </Button>
            )}
          </li>
        );
      })}
    </ul>
  );
}

Pagination.defaultProps = {
  color: "primary"
};

Pagination.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      disabled: PropTypes.bool,
      tooltip: PropTypes.bool,
      value: PropTypes.number,
      text: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf(["PREV", "NEXT", "...", "<<", "<", ">", ">>"])
      ]).isRequired,
      onClick: PropTypes.func
    })
  ).isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"])
};
